import React from "react"
import { Helmet } from "react-helmet"
import PropTypes from "prop-types"

const ColorTheme = ({ lighterColor, darkerColor }) => (
    <Helmet>
        <style>
            {`:root {--lighter-color: ${lighterColor}; --darker-color: ${darkerColor}}`}
        </style>
    </Helmet>
)

ColorTheme.propTypes = {
    lighterColor: PropTypes.string.isRequired,
    darkerColor: PropTypes.string.isRequired,
}

export default ColorTheme
